import React from 'react'
import SelectGod from './components/SelectGod'
import '@fontsource/open-sans';
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";

function SelectGodContainer() {
    return (
        <div>
          <SelectGod />  
        </div>
    )
}

export default SelectGodContainer
